import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import { App } from './App';
import { ErrorBoundary } from './App/Components/ErrorBoundary';
import { REACT_APP_KINASTIC_ENVIRONMENT } from './App/Config/environment';

console.log('Environment:', REACT_APP_KINASTIC_ENVIRONMENT);
console.log('React version:', React.version);

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
